import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styled, { ThemeProvider } from "styled-components";
import { Head, Loader, Nav, Social, Email, Footer } from "@components";
import { GlobalStyle, theme } from "@styles";

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const Layout = ({ children, location }) => {
  const isHome = location?.pathname === "/";
  const [isLoading, setIsLoading] = useState(isHome);
  const homeSchema = isHome
    ? {
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "WebSite",
            name: "Hemang Sharma",
            url: "https://sharmahemang.com",
          },
          {
            "@type": "Person",
            name: "Hemang Sharma",
            url: "https://sharmahemang.com",
            jobTitle: "Data and Analytics Engineer",
            homeLocation: {
              "@type": "Place",
              name: "Canberra, Australia",
            },
            sameAs: [
              "https://www.linkedin.com/in/sharmahemang",
              "https://github.com/hemangsharma",
            ],
            knowsAbout: [
              "Defensible analytics",
              "Award compliance modelling",
              "Underpayment modelling",
              "Legal analytics",
              "Forensic data analysis",
              "Python",
              "SQL",
              "Data engineering",
              "Data and Analytics Engineer",
            ],
          },
        ],
      }
    : null;

  // Sets target="_blank" rel="noopener noreferrer" on external links
  const handleExternalLinks = () => {
    const allLinks = Array.from(document.querySelectorAll("a"));
    if (allLinks.length > 0) {
      allLinks.forEach((link) => {
        if (link.host !== window.location.host) {
          link.setAttribute("rel", "noopener noreferrer");
          link.setAttribute("target", "_blank");
        }
      });
    }
  };

  useEffect(() => {
    if (isLoading) return;

    if (location?.hash) {
      const id = location.hash.substring(1);
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView();
          el.focus();
        }
      }, 0);
    }

    handleExternalLinks();
  }, [isLoading, location]);

  return (
    <>
      <Head
        title={isHome ? "Data and Analytics Engineer" : null}
        description={
          isHome
            ? "Data and Analytics Engineer specialising in defensible analytics, award compliance & underpayment modelling, and legal/forensic data analysis using Python and SQL."
            : null
        }
        schema={homeSchema}
      />

      <div id="root">
        <ThemeProvider theme={theme}>
          <GlobalStyle />
          <a className="skip-to-content" href="#content">
            Skip to Content
          </a>

          {isLoading && isHome ? (
            <Loader finishLoading={() => setIsLoading(false)} />
          ) : (
            <StyledContent>
              <Nav isHome={isHome} />
              <Social isHome={isHome} />
              <Email isHome={isHome} />

              <div id="content">
                {children}
                <Footer />
              </div>
            </StyledContent>
          )}
        </ThemeProvider>
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.object.isRequired,
};

export default Layout;